@if (checkingCode) {
  <div class="whole-page-spinner">
    <motn-spinner></motn-spinner>
  </div>
} @else {
  <div class="form-area">
    <div>
      <img
        class="logo"
        src="../../../assets/img/motion-R.png"
      >
      <div>
        <h4>New User Registration</h4>

        @if (invalidCode) {
          <p>
            This invitation is invalid. Please ask the person who sent the invite to send a new invitation.
          </p>
        }
      </div>
    </div>

    @if (!invalidCode) {
      <div>
        @if (succeeded) {
          <p>
            You have a Motion account now! Head to <a [routerLink]="['/login']">Login</a> to access your account.
          </p>
        } @else {
          <form>
            <div>
              <input
                type="text"
                name="name"
                spellcheck="false"
                placeholder="Name"
                aria-label="Name"
                [(ngModel)]="newUser.Name"
              >
              <div class="label">Full Name</div>

              <input
                type="text"
                name="email"
                spellcheck="false"
                placeholder="Email"
                aria-label="Email"
                [(ngModel)]="newUser.Email"
              >
              <div class="label">Email Address</div>

              <input
                type="text"
                name="username"
                spellcheck="false"
                placeholder="Username"
                aria-label="Username"
                [(ngModel)]="newUser.Username"
              >
              <div class="label">Desired Username</div>

              <div
                style="margin-bottom: 5px;"
              >
                <input
                  type="password"
                  name="password1"
                  placeholder="Password"
                  [(ngModel)]="newUser.Password"
                >
              </div>

              <div>
                <input
                  type="password"
                  name="password2"
                  placeholder="Confirm Password"
                  [(ngModel)]="newUser.PasswordConfirm"
                >
              </div>
              <div class="label">Password</div>

              <div class="label">
                <label
                  class="toggle small"
                >
                  <input
                    name="agree"
                    [(ngModel)]="agreeToEula"
                    type="checkbox"
                  >
                  <span class="slider"></span>
                </label>

                I agree to the terms of the EULA
                <a
                  target="_blank"
                  href="https://motion.cloud/eula"
                >
                  <motn-pill
                  >Click to View</motn-pill>
                </a>
              </div>
            </div>

            <div class="bottom">
              <button
                type="button"
                [ngClass]="{'loading': submitting}"
                (click)="register()"
              >
                <span>Sign Up</span>
                <motn-spinner></motn-spinner>
              </button>
            </div>
          </form>
        }
      </div>
    }

    <motn-login-help-buttons
      [excludeButtons]="['forgot-password']"
    ></motn-login-help-buttons>
  </div>
}
